import { render } from "./exchange-success.vue?vue&type=template&id=9b78881e&scoped=true&ts=true"
import script from "./exchange-success.vue?vue&type=script&lang=ts"
export * from "./exchange-success.vue?vue&type=script&lang=ts"

import "./exchange-success.vue?vue&type=style&index=0&id=9b78881e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b78881e"]])